import React, { useEffect, useState } from "react";
import { AutoSizer, Column, SortDirection, Table } from "react-virtualized";
import { getNumericComparator, getStringComparator, reverseOrder } from "@/utils/collect";
import styles from "@/components/LanguageModelArtifact/style.module.css";
import { FEEDBACK_BREAKPOINTS } from "@/containers/LanguageModelArtifact/reducer";
import { ProgressBar } from "@/components/LanguageModelArtifact/ProgressBar";
import ModelStatus from "@/components/LanguageModelArtifact/Models/ModelStatus";
import { Button } from "@/aible";
const ModelEvaluationTable = ({ data, searchFilter, handleEvaluatorAction }) => {
    // updateSelectedDataset = { updateSelectedDataset };
    // updateSelectedModel = { updateSelectedModel };
    // handleDelete = { handleDeleteTrainingDataset };
    const [sortBy, updateSortBy] = useState("createdDate");
    const [sortDirection, updateSortDirection] = useState(SortDirection.DESC);
    const [sortedData, updateSortedData] = useState(data);
    const datasetColumns = [
        { label: "Name", dataKey: "name", width: 600, flexGrow: 1 },
        { label: "Source", dataKey: "source", width: 300 },
        { label: "Status", dataKey: "status", width: 200 },
        { label: "Added By", dataKey: "owner", width: 180 },
        { label: "Date Created", dataKey: "createdDate", width: 150 },
        { label: "", dataKey: "actions", width: 60 }
    ];
    const getSortFunction = (sortBy) => {
        switch (sortBy) {
            case "createdDate":
                return getNumericComparator((x) => Date.parse(x[sortBy]));
            case "status":
            case "name":
            case "source":
            case "owner":
                return getStringComparator((x) => x[sortBy]);
            default:
                return getNumericComparator(() => 0);
        }
    };
    const sort = ({ sortBy, sortDirection }) => {
        const sortFunc = getSortFunction(sortBy);
        updateSortBy(sortBy);
        updateSortDirection(sortDirection);
        return updateSortedData(data.toSorted(sortDirection === SortDirection.ASC ? sortFunc : reverseOrder(sortFunc)));
    };
    const filteredData = sortedData.filter((item) => searchFilter === "" || searchFilter === undefined
        ? item
        : item?.name?.toLowerCase()?.includes(searchFilter?.toLowerCase()));
    useEffect(() => {
        sort({ sortBy, sortDirection });
    }, [data]);
    if (searchFilter?.length && searchFilter?.length > 0 && filteredData?.length < 1) {
        return React.createElement("div", { className: styles.noMatchingText }, "No matching datasets found");
    }
    const rowHeight = 44;
    const tableHeight = filteredData?.length * rowHeight + 30;
    return (React.createElement("div", { className: styles.dataTableWrapper },
        React.createElement(AutoSizer, null, ({ width }) => (React.createElement(Table, { width: width, height: tableHeight, headerHeight: 30, rowHeight: rowHeight, rowCount: filteredData?.length, rowGetter: ({ index }) => filteredData[index], sort: sort, sortBy: sortBy, sortDirection: sortDirection, rowClassName: styles.fineTuningRow, className: styles.fineTuningTable, headerClassName: styles.fineTuningHeaderRow }, datasetColumns.map((column, index) => {
            if (column.dataKey === "label") {
                return;
            }
            if (column.dataKey === "status") {
                return (React.createElement(Column, { key: index, label: column.label, dataKey: column.dataKey, width: column.width, className: styles.fineTuningItem, cellRenderer: ({ rowData }) => {
                        return (React.createElement("div", { className: styles.fineTuningItem },
                            React.createElement(ModelStatus, { status: rowData?.status })));
                    } }));
            }
            if (column.dataKey === "totalProgress") {
                return (React.createElement(Column, { key: index, label: column.label, dataKey: column.dataKey, width: column.width, className: styles.fineTuningItem, cellRenderer: ({ cellData }) => (React.createElement("div", { className: styles.progressCell },
                        React.createElement("div", { className: styles.progressText }, `${Math.min((cellData / FEEDBACK_BREAKPOINTS.RECOMMENDED) * 100, 100).toFixed(2)}%`),
                        React.createElement(ProgressBar, { value: (cellData / FEEDBACK_BREAKPOINTS.RECOMMENDED) * 100 }))) }));
            }
            if (column.dataKey === "actions") {
                return (React.createElement(Column, { key: index, label: column.label, dataKey: column.dataKey, width: column.width, className: styles.fineTuningSettings, cellRenderer: ({ rowData }) => {
                        if (rowData.status !== "SUCCEEDED")
                            return null;
                        return (React.createElement("div", { className: styles.fineTuningItemActions },
                            React.createElement(Button, { isSmall: true, onClick: (e) => {
                                    e.stopPropagation();
                                    console.log(rowData);
                                    handleEvaluatorAction(rowData.id);
                                }, style: { padding: "5px 7px", marginRight: "4px" } }, "Details")));
                    } }));
            }
            return (React.createElement(Column, { key: index, label: column.label, dataKey: column.dataKey, width: column.width, className: styles.fineTuningItem }));
        }))))));
};
export default ModelEvaluationTable;
